// ShortDrama Admin — entry. Vanilla TS, no UI framework (rules.md: admin = vanilla TS).
// Trust & safety + compliance + ops console over the /v1/admin/* contract (05-admin / 01 §3.M).
import { onResolve, route, setNotFound, startRouter } from "./core/router.js";
import { h, mount } from "./core/dom.js";
import { dashboardView } from "./features/dashboard.js";
import { moderationView } from "./features/moderation.js";
import { usersView, userDetailView } from "./features/users.js";
import { auditView } from "./features/audit.js";
import { loginView } from "./features/login.js";
import { contentView, contentDetailView } from "./features/content.js";
import { complianceView } from "./features/compliance.js";
import { trainingView } from "./features/training.js";
import { electionsView } from "./features/elections.js";
import { rankingView } from "./features/ranking.js";
import { summaryView } from "./features/summary.js";

route("/", dashboardView);
route("/moderation", moderationView);
route("/content", contentView);
route("/content/:id", contentDetailView);
route("/compliance", complianceView);
route("/training", trainingView);
route("/elections", electionsView);
route("/training-summary", summaryView);
route("/ranking", rankingView);
route("/users", usersView);
route("/users/:id", userDetailView);
route("/audit", auditView);
route("/login", loginView);

setNotFound((_p, root) => mount(root, h("div", { class: "state muted" }, "페이지를 찾을 수 없습니다.")));

// Sync the active sidebar link with the current route.
onResolve((path) => {
  document.querySelectorAll<HTMLAnchorElement>(".sidebar a[data-link]").forEach((a) => {
    const href = a.getAttribute("href") ?? "";
    const active = href === "/" ? path === "/" : path === href || path.startsWith(href + "/");
    a.classList.toggle("active", active);
  });
});

startRouter();
